import { useFooterActionsStore } from '@/store/footer-actions-store'

/**
 * Se monta UNA VEZ en AppLayout. Solo actúa en mobile/responsive
 * (`lg:hidden`): muestra fijo al fondo del viewport (por encima del
 * BottomNav) lo que las vistas registran vía <StickyActionBar>
 * (@/components/ui/StickyActionBar). En desktop no renderiza nada — ese
 * mismo contenido ya se ve inline, en su posición original dentro de la
 * vista, sin cambios respecto al comportamiento de siempre.
 */
/**
 * `navVisible`: el BottomNav se está dibujando (ruta root Y la vista no pidió
 * ocultarlo). Solo en ese caso el footer se apoya encima de la navbar
 * (`bottom-16`); si no, va pegado al pie del viewport (respetando el
 * safe-area inferior de iOS).
 */
export function FooterActionBar({ navVisible }: { navVisible: boolean }) {
  const content = useFooterActionsStore(s => s.content)
  if (!content) return null

  return (
    <div className={`lg:hidden fixed ${navVisible ? 'bottom-16' : 'bottom-0 pb-[max(1rem,env(safe-area-inset-bottom))]'} left-0 right-0 z-30 bg-[var(--color-background)] border-t border-[var(--color-border)] p-4`}>
      {content}
    </div>
  )
}
